module.exports = __webpack_public_path__ + "static/media/ph-d1.7c28889d.JPG";